import { Item, Offer } from '@/api';
import ProductBidModal from '@/components/ecommerce/product/ProductPage/Modals/ProductBidModal';
import ProductOfferModal from '@/components/ecommerce/product/ProductPage/Modals/ProductOfferModal';
import Share from '@/components/ecommerce/Share';
import ShareModal from '@/components/ecommerce/ShareModal';
import If from '@/components/util/IF';
import { useMobile } from '@/hooks/useMobile';
import React from 'react';
import Sheet from 'react-modal-sheet';

type ProductPageModalsProps = {
    item: Item | undefined;
    showBidding: boolean;
    setShowBidding: (show: boolean) => void;
    showOffering: boolean;
    setShowOffering: (show: boolean) => void;
    showShare: boolean;
    setShowShare: (show: boolean) => void;
    currentOffer: Offer | null | undefined;
    isEverythingLoaded: boolean;
};

const ProductPageModals = (props: ProductPageModalsProps) => {
    const isMobile = useMobile();

    const { item, showBidding, setShowBidding, showOffering, setShowOffering, showShare, setShowShare, currentOffer, isEverythingLoaded } = props;

    return (
        <>
            <ProductBidModal show={showBidding} onHide={() => setShowBidding(false)} product={item} />
            <ProductOfferModal offer={currentOffer} show={showOffering} onHide={() => setShowOffering(false)} product={item} />
            <ShareModal product={item} show={showShare && !isMobile} onHide={() => setShowShare(false)} isLoading={!isEverythingLoaded} />
            <Sheet isOpen={showShare && isMobile} onClose={() => setShowShare(false)} tweenConfig={{ ease: 'easeInOut', duration: 0.4 }}>
                <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>
                        <Sheet.Scroller>
                            <If condition={item}>
                                <Share isLoading={!isEverythingLoaded} product={item!} isMobile={isMobile} />
                            </If>
                        </Sheet.Scroller>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onTap={() => setShowShare(false)} />
            </Sheet>
        </>
    );
};

export default ProductPageModals;
